import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  PageHeader,
  Checkbox,
  Row,
  Radio,
  InputNumber,
  Spin,
} from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { db } from "../configs/firebase";
import { doc, setDoc, Timestamp } from "firebase/firestore";
import { checkQuestions } from "../utils/formdata";
import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";

// antd css
import "antd/dist/antd.min.css";
import "../styles/community-form.scss";

export default function ContactForm() {
  const navigate = useNavigate();
  const [componentSize, setComponentSize] = useState("default");
  const [loading, setLoading] = useState(false);
  // const [isNotified, setIsNotified] = useState(false);

  const [answers, setAnswers] = useState({
    name: "",
    email: "",
    survey: [],
  });

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  // function onChange(event, question) {
  //   const value = event.target.value;

  //   let newAnswers = { ...answers };
  //   const idx = newAnswers.survey.findIndex(
  //     (item) => item.question === question
  //   );

  //   if (idx >= 0) {
  //     newAnswers.survey[idx].answer = value;
  //   } else {
  //     newAnswers.survey.push({ question, answer: value });
  //   }

  //   setAnswers(newAnswers);
  // }

  function onChangeCheckbox(checkedValues, question) {
    let value = checkedValues;
    let newAnswers = { ...answers };
    const idx = newAnswers.survey.findIndex(
      (item) => item.question === question
    );

    if (idx >= 0) {
      newAnswers.survey[idx].answer = value;
    } else {
      newAnswers.survey.push({ question, answer: value });
    }

    setAnswers(newAnswers);
  }

  const onFormLayoutChange = (size) => {
    setComponentSize(size);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // check if all answers are filled

    const { name, email, age, phone, collegename, gender } = answers;
    console.log(name, email, age, phone, collegename, gender);

    if (
      !name.length ||
      !email.length ||
      age === undefined ||
      phone === undefined ||
      !collegename.length ||
      gender === undefined
    ) {
      Swal.fire({
        title: "Please fill all the fields",
        text: "Fields marked with * are required",
        icon: "error",
        confirmButtonText: "Continue",
      });
      return;
    }

    if (!validateEmail(email)) {
      Swal.fire({
        title: "Please enter a valid email",
        text: "Email you entered is not valid",
        icon: "error",
        confirmButtonText: "Continue",
      });
      return;
    }

    if (answers?.survey?.length !== checkQuestions.length) {
      Swal.fire({
        title: "All survey questions are required",
        text: "Please fill in all questions",
        icon: "error",
        confirmButtonText: "Continue",
      });
      return;
    }

    try {
      // sort survey questions on the basis of question number
      const sortedSurvey = answers.survey.sort((a, b) => {
        return a.questionNumer - b.questionNumer;
      });

      const newDoc = {
        name: answers.name,
        email: answers.email,
        age: answers.age ? answers.age : 0,
        gender: answers.gender ? answers.gender : "",
        collegename: answers.collegename ? answers.collegename : "",
        phone: answers.phone,
        createdAt: Timestamp.now(),
        survey: sortedSurvey,
      };

      setLoading(true);

      const surveyRef = doc(db, "surveys", answers.email);
      await setDoc(surveyRef, newDoc).then(async () => {
        await axios
          .post("https://formi-mailer.herokuapp.com/send", {
            name: answers.name,
            email: answers.email,
          })
          .then((res) => {
            setLoading(false);

            Swal.fire({
              title: `Thank you ${answers.name} for your response 
                      A confirmation email has been sent`,
              icon: "success",
              confirmButtonText: "Continue",
            }).then((result) => {
              if (result.isConfirmed) {
                navigate("/");
              }
            });
          })
          .catch((err) => {
            Swal.fire({
              title: "Error in sending email",
              text: err,
              icon: "error",
              confirmButtonText: "Continue",
            });
          });
      });
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  useEffect(() => {
    localStorage.clear();
  }, []);

  if (loading) {
    return (
      <div
        className="community-form"
        style={{
          background: "rgba(0, 0, 0, 0.01)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Spin size="large" />
        <p
          style={{
            color: "#FFF",
          }}
        >
          Submitting your response...
        </p>
      </div>
    );
  }

  return (
    <div className="community-form">
      <div className="community-header">
        <PageHeader
          className="community-header"
          onBack={() => navigate("/")}
          title="Join Community"
          subTitle="Please fill the survey below!"
        />
      </div>
      <div className="contact-form-container">
        <div className="heading">
          <h1>Join Our Community!</h1>
        </div>
        <Form
          className="contact-form"
          wrapperCol={{ span: 24 }}
          layout="vertical"
          initialValues={{ size: componentSize }}
          onValuesChange={onFormLayoutChange}
          size={componentSize}
        >
          <Form.Item label="Name" required>
            <Input
              placeholder="Enter your name"
              onChange={(e) => setAnswers({ ...answers, name: e.target.value })}
            />
          </Form.Item>
          <Form.Item
            required
            label="Email"
            rules={[{ required: true, message: "Please fill this field!" }]}
          >
            <Input
              type="email"
              placeholder="example@mail.com"
              onChange={(e) =>
                setAnswers({ ...answers, email: e.target.value })
              }
            />
          </Form.Item>
          <Form.Item label="College name" required>
            <Input
              placeholder="Enter your college name"
              onChange={(e) =>
                setAnswers({ ...answers, collegename: e.target.value })
              }
            />
          </Form.Item>

          <Form.Item label="Age" required>
            <InputNumber
              placeholder={"Age"}
              max={100}
              onChange={(value) => setAnswers({ ...answers, age: value || 0 })}
            />
          </Form.Item>
          <Form.Item label="Phone Number" required>
            <InputNumber
              placeholder="Phone Number"
              style={{ width: "20rem" }}
              onChange={(value) =>
                setAnswers({ ...answers, phone: value || 0 })
              }
            />
          </Form.Item>

          {/* Gender radio question */}
          <Form.Item label="Gender" required>
            <Radio.Group
              onChange={(e) => {
                setAnswers({ ...answers, gender: e.target.value });
              }}
            >
              <Radio value={"Male"}>Male</Radio>
              <Radio value={"Female"}>Female</Radio>
              <Radio value={"Others"}>Others</Radio>
            </Radio.Group>
          </Form.Item>

          {checkQuestions.map((question, idx) => (
            <Form.Item required label={question.questionHeader} key={idx}>
              <Checkbox.Group
                onChange={(e) => onChangeCheckbox(e, question.questionHeader)}
              >
                {question.options.map((option, idx) => (
                  <Checkbox
                    style={{
                      marginLeft: 0,
                      color: "#FFF",
                      marginBottom: "0.5rem",
                    }}
                    value={option.label}
                    key={idx}
                  >
                    {option.label}
                  </Checkbox>
                ))}
              </Checkbox.Group>
            </Form.Item>
          ))}

          <Row justify="center">
            <Button className="join-now" onClick={handleSubmit}>
              SUBMIT
            </Button>
          </Row>
        </Form>
      </div>
    </div>
  );
}
